const $ = require('jquery');
require('bootstrap-datepicker');

window.addEventListener('load', function () {
  function getLanguage() {
    return $('html').prop('lang');
  }
  // http://stackoverflow.com/a/4161126
  const tester = document.createElement('input');

  const supportedInputTypes = ['date', 'number', 'time'].map((t) => {
    tester.type = t;
    tester.value = ':(';

    return tester.type === t && tester.value === '' ? t : null;
  });

  const datepickerOptions = {
    todayHighlight: true,
    language: getLanguage(),
  };

  // eslint-disable-next-line no-unused-expressions, func-names
  !(function (a) {
    // eslint-disable-next-line no-param-reassign
    a.fn.datepicker.dates.de = {
      days: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
      ],
      daysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
      daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      monthsShort: [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
      ],
      today: 'Heute',
      monthsTitle: 'Monate',
      clear: 'Löschen',
      weekStart: 1,
      format: 'dd.mm.yyyy',
    };
  })($);

  function refreshHiddenDate(el) {
    if (typeof $(el).datepicker !== 'undefined') {
      if ($(el).datepicker('getUTCDates').length > 0) {
        const ymd = $(el)
          .datepicker('getUTCDates')[0]
          .toISOString()
          .slice(0, 10);
        $(`input[name="${$(el).prop('name')}_ymd"]`).val(ymd);
      }
    }
  }

  if ($.inArray('date', supportedInputTypes) === -1) {
    /* if ($('input[type=date]').length > 0) {
            $('#polyfill-date-warning').removeClass('hidden');
            $('input[type=date]')
                .each((index, el) => {
                    const $el = $(el);
                    $el.closest('form').find('button[type=submit]').prop('disabled', 'disabled');
                });
        } */

    $('input[type=date]')
      .attr('placeholder', 'Datum')
      .attr('type', 'date-text')
      .each((index, el) => {
        const $el = $(el);
        if ($el.val() !== '') {
          const lang = datepickerOptions.language;
          $el.val($el.data(`value-${lang}`));
        }
        $el.after(`<input type="hidden" name="${$el.prop('name')}_ymd">`);
      });
    $('input[type=date-text]')
      .datepicker(datepickerOptions)
      .on('change', (e) => {
        refreshHiddenDate(e.currentTarget);
      })
      .each((index, el) => {
        $(el)
          .closest('form')
          .on('submit', () => {
            $('input[type=date-text]').each((index2, el2) => {
              refreshHiddenDate(el2);
              const name = $(el2).prop('name');
              const $other = $(`input[name="${name}_ymd"]`);
              $(el).prop('name', '');
              $other.prop('name', name);
            });
          });
      });
  }

  if ($.inArray('time', supportedInputTypes) === -1) {
    $('input[type=time]').attr('placeholder', 'Zeit');
  }
});
